<template>
    <div>
        <component :is="component_name" v-bind="props"></component>
    </div>
</template>

<script>
import InvitationForm from '../invitation-form/invitation-form.vue';
import CtaForm from '../invitation-form/cta-form.vue';
import GuestLeadForm from '../invitation-form/guest-lead-form.vue';

export default {
    components: { InvitationForm, CtaForm, GuestLeadForm },
    props: [
        'authenticated',
        'chat_visible',
        'cta_url',
        'fk_property_ad',
        'location_object',
        'message_sent',
        'pinvitation',
        'proommate',
        'rent_price',
        'user'
    ],
    data: function () {
        return {
            component_name: InvitationForm
        }
    },
    computed: {
        props: function () {
            return {
                'authenticated': this.authenticated,
                'chat_visible': this.chat_visible,
                'cta_url': this.cta_url,
                'fk_property_ad': this.fk_property_ad,
                'location_object': this.location_object,
                'message_sent': this.message_sent,
                'pinvitation': this.pinvitation,
                'proommate': this.proommate,
                'rent_price': this.rent_price,
                'user': this.user,
            };
        }
    },
    created() {
        if (!this.authenticated && !this.chat_visible) {
            this.component_name = GuestLeadForm;
        } else if (this.cta_url !== '') {
            this.component_name = CtaForm;
        }

        EventBus.$on('view-invitation-form', () => {
            this.component_name = InvitationForm;
        });
    }
}
</script>
